import { LOGO } from '@bitstopco/bitstop-theme/constants';

import { Box, useMediaQuery } from '@mui/material';
import type { Theme } from '@mui/material';
import { Link } from 'react-router-dom';

const HeaderLogo = () => {
  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  const logoSize = mdDown
    ? {
        width: 90,
        height: 18.03,
      }
    : {
        width: 148,
        height: 29.66,
      };

  return (
    <Box
      component={Link}
      to="/"
      sx={{
        mr: {
          lg: '24px',
          xs: 0,
        },
      }}
    >
      <img loading="lazy" src={LOGO} alt="bitstop logo" style={{ display: 'block', ...logoSize }} />
    </Box>
  );
};

export default HeaderLogo;
